export default __webpack_public_path__ + "static/media/Yankees.16d0f63d.png";